<vue-select :id="id" :ref="id" :title="title" :placeholder="placeholder" :value="value" @input="handleInput"
    :components="{OpenIndicator, Deselect}" :options="options" @search="onSearch" @option:created="onCreated"
    :reduce="item => item.text || item" :close-on-select="!multiple" :select-on-key-codes="[9, 13]"
    :filterable="false" label="text" :multiple="multiple" :taggable="taggable">
    <spinner slot="spinner" slot-scope="spinner" v-show="spinner.loading"/>
    <template slot="no-options">{{noOptionsLabel}}</template>
</vue-select>